import { SortOrder as SearchSortOrder } from "gen/search/service/service_pb"
import { useCallback } from "react"

import { SortOrder } from "./helpers"
import { UseSearchSortProps, UseSearchSortRes } from "./types"

export function useSearchSort<ItemT>(
  props: UseSearchSortProps<ItemT>
): UseSearchSortRes<ItemT> {
  const { useSort, ...restProps } = props

  const orderExtractor = useCallback((order: SortOrder | null) => {
    if (!order) return SearchSortOrder.NONE
    return {
      [SortOrder.Ascending]: SearchSortOrder.ASC,
      [SortOrder.Descending]: SearchSortOrder.DESC,
    }[order]
  }, [])

  const res = useSort({
    ...restProps,
    orderExtractor,
  })

  return {
    ...res,
    order: res.order ?? SearchSortOrder.NONE,
  }
}
